import { IValidator, ILoginCredentials, IValidations } from '@/interfaces';
import { isEmail, empty } from '@/utils';

export class LoginValidator implements IValidator<ILoginCredentials> {
  public isValid(item: ILoginCredentials) {
    const errors: IValidations<ILoginCredentials> = {};
    // Validate email
    if (!isEmail(item.userEmail)) errors.userEmail = ['Email must be a valid email address'];

    // Validate password
    if (empty(item.password)) errors.password = ['Password is required'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}